import { render, staticRenderFns } from "./OccasionOverview.vue?vue&type=template&id=6b6809b8&"
import script from "./OccasionOverview.vue?vue&type=script&lang=js&"
export * from "./OccasionOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../themes/custom/ef2_custom/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports